import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleProcessingShipmentPin } from "../../../services/supplierOrderService";
import { shipmentKeys } from "../queryKeys";

const updateShipmentPinInList = (oldData, shipmentCode, isPinned) => {
  if (!oldData) return oldData;

  // اگر response صفحه‌بندی‌شده DRF باشد: { count, next, previous, results: [] }
  if (Array.isArray(oldData.results)) {
    return {
      ...oldData,
      results: oldData.results.map((shipment) =>
        shipment.shipment_code === shipmentCode
          ? {
              ...shipment,
              is_pinned_by_supplier: isPinned,
            }
          : shipment
      ),
    };
  }

  // اگر response آرایه ساده باشد
  if (Array.isArray(oldData)) {
    return oldData.map((shipment) =>
      shipment.shipment_code === shipmentCode
        ? {
            ...shipment,
            is_pinned_by_supplier: isPinned,
          }
        : shipment
    );
  }

  return oldData;
};

export const useToggleProcessingShipmentPin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ shipmentCode, isPinned }) =>
      toggleProcessingShipmentPin(shipmentCode, isPinned),

    onMutate: async ({ shipmentCode, isPinned }) => {
      await queryClient.cancelQueries({
        queryKey: shipmentKeys.all,
      });

      const previousQueries = queryClient.getQueriesData({
        queryKey: shipmentKeys.all,
      });

      queryClient.setQueriesData(
        {
          queryKey: shipmentKeys.all,
        },
        (oldData) => updateShipmentPinInList(oldData, shipmentCode, isPinned)
      );

      return {
        previousQueries,
      };
    },

    onError: (_error, _variables, context) => {
      if (!context?.previousQueries) return;

      context.previousQueries.forEach(([queryKey, data]) => {
        queryClient.setQueryData(queryKey, data);
      });
    },

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: shipmentKeys.all,
      });
    },
  });
};
